export default defineNuxtRouteMiddleware((to, from) => {
  if (/[A-Z]/.test(to.path)) {
    const lowerCasePath = to.path.toLowerCase();

    return navigateTo(lowerCasePath, { redirectCode: 301 });
  }
});
